import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';
// import { AppContext, AppContextInterface } from '../app-context-provider';
import { PageItem } from '../components/component-switcher';
import Img from './Img';
// import mediaQuery from '../media-query';
import { LangContext } from '../contexts/Lang';

export interface FontComponentProps extends PageItem {
  externalSourceText: string;
  externalSourceLink: string;
  fontFamilyName: string;
  liveFontLocation: string;
  usageRestrictions: string;
  accreditationRequirements: string;
  previewImage: Array<{
    id: number;
    key: string;
    slug: string;
    url: string;
    title: string;
    umbracoExtension: string;
    type: string;
  }>;
}

export interface FontComponentState {}

const FontComponent = (props: FontComponentProps) => {
  const { globalPageData } = useContext(LangContext);
  let fontStyle = { fontFamily: `${props.fontFamilyName}` };

  // <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600&family=Oswald&display=swap" rel="stylesheet"></link>

  //let textstring = "ABCČĆDĐEFGHIJKLMNOPQRSŠTUVWXYZŽabcčćdđefghijklmnopqrsštuvwxyzžАБВГҐДЂЕЁЄЖЗЅИІЇЙЈКЛЉМНЊОПРСТЋУЎФХЦЧЏШЩЪЫЬЭЮЯабвгґдђеёєжзѕиіїйјклљмнњопрстћуўфхцчџшщъыьэюяΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωάΆέΈέΉίϊΐΊόΌύΰϋΎΫΏĂÂÊÔƠƯăâêôơư1234567890‘?’“!”(%)[#]{@}/&\\<-+÷×=>®©$€£¥¢:;,.*";
  let previewStyle: React.CSSProperties = {
    ...fontStyle,
  };
  // if (props.liveFontLocation) {
  //   let body = document.body;
  //   let link = document.createElement('link');
  //   link.setAttribute('href', props.liveFontLocation);
  //   link.setAttribute('ref', 'stylesheet');
  //   body.appendChild(link);
  // }
  return (
    <div className='font-component'>
      <h3 style={fontStyle}>{props.title}</h3>
      {props.description[0]?.replace(/(<([^>]+)>)/gi, '') !== props.title && (
        <div
          dangerouslySetInnerHTML={{
            __html: props.description,
          }}
        />
      )}
      {props.previewImage?.length > 0 ? (
        props.previewImage?.map((img) => (
          <Img src={img.url} alt={img.title} style={{ maxWidth: '100%' }} />
        ))
      ) : (
        <>
          {props.liveFontLocation && (
            <div className='text-preview' style={previewStyle}>
              <h5>Aa</h5>
              <p>ABCDEFGHIJKLMNOPQRSTUVWXYZÆØÅ</p>
              <p>abcdefghijklmnopqrstuvwxyzæøå</p>
              <p>1234567890</p>
            </div>
          )}
        </>
      )}

      <p
        className='small-print'
        dangerouslySetInnerHTML={{
          __html: props.usageRestrictions,
        }}
      />

      <div className='item-downloads-container'>
        <div
          dangerouslySetInnerHTML={{
            __html: props.externalSourceText,
          }}
        />
        {props.externalSourceLink && (
          <a
            // style={{
            //   color: this.context.styles?.bodyText.vibrant,
            // }}
            rel='noopener noreferrer'
            target='_blank'
            href={props.externalSourceLink}>
            <span>
              {globalPageData.fontenKanLastesNedHer ||
                'Fonten kan lastes ned her'}{' '}
            </span>
            <FontAwesomeIcon icon={faExternalLinkAlt} />
          </a>
        )}
      </div>
    </div>
  );
};

// class FontComponent extends React.Component<
//   FontComponentProps,
//   FontComponentState
// > {
//   static contextType: Context<AppContextInterface | null> = AppContext;
//   public context!: AppContextInterface;
//   state: FontComponentState = {};

//   constructor(props: FontComponentProps) {
//     super(props);
//     this.downloadFile = this.downloadFile.bind(this);
//   }

//   public downloadFile(event: React.MouseEvent<HTMLElement>): void {
//     console.log(event);
//   }

//   render() {
//     let fontStyle = { fontFamily: `${this.props.fontFamilyName}` };

//     // <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600&family=Oswald&display=swap" rel="stylesheet"></link>

//     //let textstring = "ABCČĆDĐEFGHIJKLMNOPQRSŠTUVWXYZŽabcčćdđefghijklmnopqrsštuvwxyzžАБВГҐДЂЕЁЄЖЗЅИІЇЙЈКЛЉМНЊОПРСТЋУЎФХЦЧЏШЩЪЫЬЭЮЯабвгґдђеёєжзѕиіїйјклљмнњопрстћуўфхцчџшщъыьэюяΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωάΆέΈέΉίϊΐΊόΌύΰϋΎΫΏĂÂÊÔƠƯăâêôơư1234567890‘?’“!”(%)[#]{@}/&\\<-+÷×=>®©$€£¥¢:;,.*";
//     let previewStyle: React.CSSProperties = {
//       ...fontStyle,
//     };
//     // if (this.props.liveFontLocation) {
//     //   let body = document.body;
//     //   let link = document.createElement('link');
//     //   link.setAttribute('href', this.props.liveFontLocation);
//     //   link.setAttribute('ref', 'stylesheet');
//     //   body.appendChild(link);
//     // }
//     return (
//       <div className='font-component'>
//         <h3 style={fontStyle}>{this.props.title}</h3>
//         {this.props.description[0]?.replace(/(<([^>]+)>)/gi, '') !==
//           this.props.title && (
//           <div
//             dangerouslySetInnerHTML={{
//               __html: this.props.description,
//             }}
//           />
//         )}
//         {this.props.previewImage?.length > 0 ? (
//           this.props.previewImage?.map((img) => (
//             <Img src={img.url} alt={img.title} style={{ maxWidth: '100%' }} />
//           ))
//         ) : (
//           <>
//             {this.props.liveFontLocation && (
//               <div className='text-preview' style={previewStyle}>
//                 <h5>Aa</h5>
//                 <p>ABCDEFGHIJKLMNOPQRSTUVWXYZÆØÅ</p>
//                 <p>abcdefghijklmnopqrstuvwxyzæøå</p>
//                 <p>1234567890</p>
//               </div>
//             )}
//           </>
//         )}

//         <p
//           className='small-print'
//           dangerouslySetInnerHTML={{
//             __html: this.props.usageRestrictions,
//           }}
//         />

//         <div className='item-downloads-container'>
//           <div
//             dangerouslySetInnerHTML={{
//               __html: this.props.externalSourceText,
//             }}
//           />
//           {this.props.externalSourceLink && (
//             <a
//               // style={{
//               //   color: this.context.styles?.bodyText.vibrant,
//               // }}
//               rel='noopener noreferrer'
//               target='_blank'
//               href={this.props.externalSourceLink}>
//               <span>Fonten kan lastes ned her</span>
//               <FontAwesomeIcon icon={faExternalLinkAlt} />
//             </a>
//           )}
//         </div>
//       </div>
//     );
//   }
// }

export default FontComponent;
